<div class="dropup zas-info-directive zbd-info">
    <div class="dropdown-toggle">
        <span
            class="zbd-action-icon {{ icon }} tracking-action"
            (click)="open()"
        ></span>
    </div>
</div>
